import { AllPrivacySettings } from 'types/profile';
import { PrivacyGroupProps } from './PrivacyGroup';

export const getPrivacyGroups = (
  privacySettings: AllPrivacySettings = {}
): Omit<PrivacyGroupProps, 'handleToggle'>[] => {
  const {
    privacySettingsCollab,
    privacySettingsInternal,
    privacySettingsPublic,
  } = privacySettings;

  return [
    {
      description:
        'Manage how your profile information may be visible to other Salt Sessions users, and to others outside the platform.\n Your profile picture and Display name is always shown to your Song collaborators.',
      learnMoreLink:
        'https://support.sessionstudio.com/en/articles/8697726-privacy',
      master: {
        id: 'master',
        title: 'Share profile information',
        enabled:
          !!privacySettingsCollab?.basic ||
          !!privacySettingsInternal?.basic ||
          !!privacySettingsPublic?.basic,
      },
      items: [],
    },
    {
      title: 'Song collaborators',
      description:
        'Manage what additional profile information your Song collaborators may be able to see.',
      learnMoreLink:
        'https://support.sessionstudio.com/en/articles/8697726-privacy',
      master: {
        id: 'privacySettingsCollab',
        title: 'Allow sharing',
        enabled: !!privacySettingsCollab?.basic,
      },
      items: [
        {
          id: 'email',
          title: 'Email',
          enabled: !!privacySettingsCollab?.email,
        },
        {
          id: 'artistName',
          title: 'Artist name',
          enabled: !!privacySettingsCollab?.artistName,
        },
        {
          id: 'reps',
          title: 'Representatives information',
          description: 'Your publisher or label contact information',
          enabled: !!privacySettingsCollab?.reps,
        },
      ],
    },
    {
      title: 'All Session Studio users',
      description:
        'Manage your Profile searchability and what additional profile information other Session Studio users may be able to see.',
      learnMoreLink:
        'https://support.sessionstudio.com/en/articles/8697726-privacy',
      master: {
        id: 'privacySettingsInternal',
        title: 'Allow sharing',
        description: 'Also makes your Profile searchable for Song invites',
        enabled: !!privacySettingsInternal?.basic,
      },
      items: [
        {
          id: 'email',
          title: 'Email',
          enabled: !!privacySettingsInternal?.email,
        },
        {
          id: 'artistName',
          title: 'Artist name',
          enabled: !!privacySettingsInternal?.artistName,
        },
        {
          id: 'idNumbers',
          title: 'ID numbers',
          description: 'Your ID identifiers',
          enabled: !!privacySettingsInternal?.idNumbers,
        },
        {
          id: 'reps',
          title: 'Representatives information',
          description: 'Your publisher or label contact information',
          enabled: !!privacySettingsInternal?.reps,
        },
      ],
    },
    {
      title: 'Publicly to anyone',
      description:
        'Manage what profile information anyone may be able to see, e.g in. Audio share links.',
      learnMoreLink:
        'https://support.sessionstudio.com/en/articles/8697726-privacy',
      master: {
        id: 'privacySettingsPublic',
        title: 'Allow sharing',
        description:
          'Your Display name and profile picture will be shared by default when this is on.',
        enabled: !!privacySettingsPublic?.basic,
      },
      items: [
        {
          id: 'email',
          title: 'Email',
          enabled: !!privacySettingsPublic?.email,
        },
        {
          id: 'artistName',
          title: 'Artist name',
          enabled: !!privacySettingsPublic?.artistName,
        },
        {
          id: 'idNumbers',
          title: 'ID numbers',
          description: 'Your ID identifiers',
          enabled: !!privacySettingsPublic?.idNumbers,
        },
        {
          id: 'reps',
          title: 'Representatives information',
          description: 'Your publisher or label contact information',
          enabled: !!privacySettingsPublic?.reps,
        },
      ],
    },
  ];
};
